import { useState } from 'react'

import { t } from '@ctcells/i18n'
import { useNavigate } from 'react-router'

import { Button } from '../atoms/Button.tsx'
import { ScreenState } from '../screens/ScreenState.tsx'

import './shell.css'

/**
 * 없는 주소.
 *
 * 🔴 **셸 «안»에 선다**(2026-09-22 · eric 이 `/history` 로 들어가 본 화면). 종전에는 라우트 표
 *    맨 바깥에 걸려 있어서 헤더도 작업 줄도 없이 **맨 글자 + 브라우저 기본 파란 밑줄 링크**가
 *    화면 왼쪽 위에 떴다. 주소 하나 잘못 쳤다고 **E-STOP 에 닿을 길이 사라지면 안 된다** —
 *    그래서 표에서 이 화면을 셸 자식으로 옮겼다(`apps/console/src/routes.tsx`).
 * 🔴 **앱마다 처음 화면이 다르므로 `/` 로만 보낸다** — 각 앱의 루트 라우트가 알아서 보낸다.
 *    여기서 `/monitoring` 을 박으면 모듈 앱 3개에서 또 없는 주소가 된다.
 * ⚠ 「이전 화면」은 **되돌아갈 이력이 있을 때만** 그린다. 없으면 아무 일도 안 하는 죽은
 *   버튼이 되고, 죽은 버튼은 비활성 + 사유보다 나쁘다(눌러 봐야 알 수 있다).
 */
export function NotFoundScreen() {
  const navigate = useNavigate()
  /* 마운트 시점의 이력 길이로 한 번만 판정한다 — 이 화면 안에서는 늘어날 일이 없다 */
  const [canGoBack] = useState(() => globalThis.history.length > 1)

  return (
    <ScreenState
      actions={
        <>
          <Button onClick={() => void navigate('/')} size="md" variant="primary">
            {t('app.home')}
          </Button>
          {canGoBack ? (
            <Button onClick={() => void navigate(-1)} size="md">
              {t('app.back')}
            </Button>
          ) : null}
        </>
      }
      text={t('app.notFound.body')}
      title={t('app.notFound')}
    />
  )
}
